<script lang="ts">
  import { BulletPoint } from '../../components/index';
  import HeroHeader from './components5/HeroHeader.svelte';
  import HeroButton from './components5/HeroButton.svelte';
  import StepOne from './components5/StepOne.svelte';
  import StepTwo from './components5/StepTwo.svelte';
  import CheckboxQuestion from './components5/CheckboxQuestion.svelte';
  import RadioQuestion from './components5/RadioQuestion.svelte';
  import StepForm from './components5/StepForm.svelte';
  import StepThanks from './components5/StepThanks.svelte';
  import type { Hero3 } from '../types';
  import type { MktSettings } from 'customer-components/lib/types';
  import { getContext } from 'svelte';

  export let properties: Hero3;
  export let settings: MktSettings;

  const hash = getContext('hash');

  // Filter items to only include those with at least one option
  $: filteredItems =
    properties.items?.filter(item => item.options?.length > 0) || [];

  console.log('properties thankYou', properties.thankYou);

  let step: string = 'first';
  let formQuestionsNumber: number = 1;
  let showSteps: boolean = false;
  let formData = {
    name: '',
    email: '',
    phone: '',
    zipCode: '',
    message: '',
  };

  let questionAnswers: {
    questionKey: string;
    question: string;
    answers: string[];
  }[] = [];

  function transformString(inputString: string) {
    const cleanedString = inputString.replace(/[^a-zA-Z0-9\s]/g, '');
    const lowercasedString = cleanedString.toLowerCase();
    const finalString = lowercasedString.replace(/\s+/g, '-');
    return finalString;
  }

  function handleQuestionAnswer(event: CustomEvent) {
    const { selected, question } = event.detail;
    questionAnswers = [
      ...questionAnswers,
      {
        questionKey: transformString(question),
        question: question,
        answers: selected,
      },
    ];

    if (formQuestionsNumber < filteredItems.length) {
      formQuestionsNumber++;
    } else {
      step = 'form-data';
    }
  }

  function handleFormSubmit(event: CustomEvent) {
    const { formData: newFormData, form } = event.detail;
    formData = newFormData;

    properties.submitLead(
      { target: form },
      {
        comments: formData.message,
        questions: questionAnswers,
        fullName: formData.name,
        email: formData.email,
        phone: formData.phone,
        zipCode: formData.zipCode,
        hash: hash,
      },
    );

    step = 'thanks';
  }
</script>

<section class="new-hero-font py-8 sm:py-12 lg:py-20">
  <div class="container mx-auto px-4">
    <div
      class="mx-auto flex flex-col gap-8 text-[#111111] md:flex-row md:items-stretch md:gap-[60px] xl:max-w-[1280px]"
    >
      <div class="w-full md:hidden">
        <HeroHeader
          mainHeadline={properties.headline.value}
          subHeadline={properties.subHeadline.value}
        />
      </div>

      <div class="flex w-full flex-col md:order-2 md:w-1/2 xl:w-[690px]">
        {#if step === 'first'}
          <StepOne
            pricingTag={properties.pricingTag}
            img={properties.image.value}
            on:nextStep={event => (step = event.detail.step)}
          />
        {:else if step === 'second'}
          <StepTwo
            phoneNumber={settings.phoneNumber.value}
            on:nextStep={event => {
              step = event.detail.step;
              showSteps = event.detail.showSteps;
            }}
          />
        {:else if step === 'third'}
          {#if filteredItems[formQuestionsNumber - 1].type === 'checkbox'}
            <CheckboxQuestion
              step={formQuestionsNumber}
              pollsSum={filteredItems.length}
              services={filteredItems[formQuestionsNumber - 1].options.map(
                opt => ({ value: opt, label: opt }),
              )}
              selected={[]}
              data={filteredItems[formQuestionsNumber - 1]}
              on:next={handleQuestionAnswer}
              title={properties.form.title.value}
            />
          {:else if filteredItems[formQuestionsNumber - 1].type === 'radio-button'}
            <RadioQuestion
              step={formQuestionsNumber}
              pollsSum={filteredItems.length}
              options={filteredItems[formQuestionsNumber - 1].options.map(
                opt => ({ value: opt, label: opt }),
              )}
              selected=""
              data={filteredItems[formQuestionsNumber - 1]}
              on:next={handleQuestionAnswer}
              title={properties.form.title.value}
            />
          {:else}
            <h2>Error</h2>
          {/if}
        {:else if step === 'form-data'}
          <StepForm
            pollsSum={filteredItems?.length ?? 0}
            {showSteps}
            title={properties.form.title.value}
            data={properties.form}
            on:next={handleFormSubmit}
          />
        {:else if step === 'thanks'}
          <StepThanks data={properties.thankYou} />
        {/if}
      </div>
      <div class="flex flex-1 flex-col gap-4 md:order-1 md:gap-8">
        <div class="md:order-3">
          <div
            class="flex flex-col items-center justify-center gap-3 md:items-start md:justify-start"
          >
            {#if step === 'first' && properties.button.active}
              <div class="w-full sm:w-[280px]">
                <HeroButton
                  text={properties.button.label}
                  iconName={properties.buttonIcon.active
                    ? properties.buttonIcon.value
                    : ''}
                  onClick={() => (step = 'second')}
                />
              </div>
            {/if}

            {#if properties.caption?.value}
              <a class="hero-stars-and-reviews" href="#testimonial">
                <p>{@html properties.caption.value}</p>
              </a>
            {/if}
          </div>
        </div>
        <div>
          <div class="hidden w-full md:block">
            <HeroHeader
              mainHeadline={properties.headline.value}
              subHeadline={properties.subHeadline.value}
            />
          </div>
          <div class="space-y-4 text-[#111111A3]">
            <p class="leading-normal">
              {@html properties.description.value}
            </p>
          </div>
        </div>
        {#if properties.callouts.active}
          <ul class="list-none space-y-4">
            {#each properties.callouts.value as item}
              <li class="new-hero-list-item flex items-start gap-3">
                <div class="my-0.5 text-[#8DC63F]">
                  <BulletPoint bulletIcon={properties.callouts.icon} />
                </div>
                <p>{@html item}</p>
              </li>
            {/each}
          </ul>
        {/if}
      </div>
    </div>
  </div>
</section>

<style lang="scss">
  :global(.new-hero-font) {
    font-family: 'Inter Tight', sans-serif;
  }
</style>
